import { SectionHeader } from '../components/SectionHeader';
import { TerminalWindow } from '../components/TerminalWindow';
import { stack } from '../data/stack';
import styles from './Stack.module.css';

export function Stack() {
  return (
    <section id="stack" className="band">
      <div className="container content">
        <SectionHeader
          prompt="$ dpkg -l | grep seaxdev-stack"
          title={<>Tools &amp; technologies</>}
          intro="The stack we work with every day, from .NET and React to PostgreSQL, Google Cloud and AI."
        />
        <div className={styles.grid}>
          {stack.map((panel) => (
            <TerminalWindow
              key={panel.path}
              title={panel.path}
              controls={false}
              bodyClassName={styles.body}
            >
              <ul className={styles.list} aria-label={panel.path}>
                {panel.items.map(({ name, icon: IconComponent }) => (
                  <li key={name} className={styles.row}>
                    <span className={styles.ii} aria-hidden="true">
                      ii
                    </span>
                    <span className={styles.icon}>
                      <IconComponent size={20} />
                    </span>
                    <span className={styles.name}>{name}</span>
                  </li>
                ))}
              </ul>
            </TerminalWindow>
          ))}
        </div>
      </div>
    </section>
  );
}
